import MainLayout from "src/MainLayout/MainLayout";

export default MainLayout;
